import type { Api } from '@cocoonspace/types/shared/api'
import type { AxiosInstance, AxiosRequestConfig } from 'axios'

import { defineEndpoint } from '../utils/define-endpoint'

export interface ListInvoices {
	params?: NonNullable<Api.Operations['listInvoices']['parameters']>['query']
	response: Api.Operations['listInvoices']['responses']['200']['content']['application/json']
}

export const listInvoices = (
	axiosInstance: AxiosInstance,
	overideConfig?: AxiosRequestConfig,
) =>
	defineEndpoint<ListInvoices>(
		{
			method: 'get',
			url: '/invoices',
			...overideConfig,
		},
		axiosInstance,
	)
